import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import gsap from 'gsap';

const data = [
  {
    place: 'Sertifikalı Eğitim',
    title: 'TEMEL',
    title2: 'İLKYARDIM',
    description: 'İş yerlerinde zorunlu olan temel ilkyardım eğitimi ile çalışanlarınızı acil durumlara hazırlayın.',
    image: 'https://public.readdy.ai/ai/img_res/eb955bfe19e8a1a50cd2cb34cf3bc4a8.jpg'
  },
  {
    place: 'Yenileme Eğitimi',
    title: 'İLKYARDIM',
    title2: 'GÜNCELLEME',
    description: 'İlkyardımcı belgenizin süresi dolmak üzere mi? Güncelleme eğitimimiz ile bilgilerinizi tazeleyin.',
    image: 'https://readdy.ai/api/search-image?query=Advanced%20medical%20training%20refresher%20course%20with%20experienced%20instructor%20demonstrating%20modern%20emergency%20response%20techniques%20to%20healthcare%20professionals%20in%20bright%20contemporary%20training%20facility%20with%20updated%20medical%20equipment%20and%20certification%20materials%20professional%20learning%20environment&width=800&height=600&seq=202&orientation=landscape'
  },
  {
    place: 'İş Güvenliği',
    title: 'YÜKSEKTE',
    title2: 'ÇALIŞMA',
    description: 'Yüksekte çalışma riskleri ve güvenlik önlemleri hakkında kapsamlı eğitim.',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20height%20safety%20training%20with%20workers%20wearing%20harnesses%20and%20safety%20equipment%20on%20scaffolding%20structure%20professional%20occupational%20safety%20training%20scene%20with%20blue%20sky%20background%20and%20construction%20environment&width=800&height=600&seq=3&orientation=landscape'
  },
  {
    place: 'Acil Durum',
    title: 'YANGIN',
    title2: 'EĞİTİMİ',
    description: 'Yangın güvenliği ve acil tahliye eğitimi ile iş yerinizi güvende tutun.',
    image: 'https://readdy.ai/api/search-image?query=Fire%20safety%20training%20with%20fire%20extinguisher%20demonstration%20and%20controlled%20flames%20in%20professional%20training%20facility%20firefighters%20and%20safety%20equipment%20orange%20flames%20against%20dark%20background%20dramatic%20lighting&width=800&height=600&seq=4&orientation=landscape'
  },
  {
    place: 'Sağlık ve Güvenlik',
    title: 'HİJYEN',
    title2: 'EĞİTİMİ',
    description: 'Gıda işletmeleri ve sağlık sektörü için zorunlu hijyen eğitimi.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20hygiene%20training%20in%20food%20industry%20setting%20with%20workers%20in%20white%20uniforms%20and%20hairnets%20demonstrating%20proper%20hand%20washing%20and%20sanitation%20procedures%20clean%20modern%20kitchen%20environment&width=800&height=600&seq=5&orientation=landscape'
  },
  {
    place: 'MYK Belgeli',
    title: 'MESLEKİ',
    title2: 'EĞİTİMLER',
    description: 'Mesleki Yeterlilik Kurumu onaylı belgelendirme sınavlarına hazırlık.',
    image: 'https://readdy.ai/api/search-image?query=Vocational%20training%20center%20with%20forklift%20operation%20and%20industrial%20machinery%20training%20professional%20certification%20course%20with%20workers%20in%20safety%20vests%20and%20helmets%20warehouse%20environment%20with%20equipment&width=800&height=600&seq=6&orientation=landscape'
  },
];

export default function Home() {
  const containerRef = useRef<HTMLDivElement>(null);
  const initialized = useRef(false);

  useEffect(() => {
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
    document.title = 'Adana İlkyardım Eğitimi | Sağlık Bakanlığı Onaylı Sertifikalı Eğitim Merkezi';
    
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
    };
  }, []);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    const container = containerRef.current;
    if (!container) return;

    const demoEl = container.querySelector('#demo');
    
    const cards = data.map((i, index) => `<div class="card" id="card${index}" style="background-image:url(${i.image})" role="img" aria-label="${i.title} ${i.title2} eğitimi görseli"></div>`).join('');
    const cardContents = data.map((i, index) => `<div class="card-content" id="card-content-${index}">
      <div class="content-start"></div>
      <div class="content-place">${i.place}</div>
      <div class="content-title-1">${i.title}</div>
      <div class="content-title-2">${i.title2}</div>
    </div>`).join('');

    if (demoEl) demoEl.innerHTML = cards + cardContents;

    const ease = "sine.inOut";
    let order = [0, 1, 2, 3, 4, 5];
    let detailsEven = true;

    function getResponsiveValues() {
      const { innerHeight: height, innerWidth: width } = window;
      const isMobile = width <= 768;
      const isTablet = width <= 1024 && width > 768;
      
      let cardWidth = 200, cardHeight = 300, gap = 40;
      let offsetTop = height - 430, offsetLeft = width - 830;
      
      if (isMobile) {
        cardWidth = 100; cardHeight = 150; gap = 15;
        offsetTop = height - 220; offsetLeft = 15;
      } else if (isTablet) {
        cardWidth = 150; cardHeight = 220; gap = 25;
        offsetTop = height - 320; offsetLeft = width - 550;
      }
      
      offsetLeft = Math.max(15, offsetLeft);
      offsetTop = Math.max(180, offsetTop);
      
      return { cardWidth, cardHeight, gap, offsetTop, offsetLeft, width, height, isMobile, isTablet };
    }

    function init() {
      const [active, ...rest] = order;
      const detailsActive = detailsEven ? "#details-even" : "#details-odd";
      const detailsInactive = detailsEven ? "#details-odd" : "#details-even";
      const { cardWidth, cardHeight, gap, offsetTop, offsetLeft, width, height, isMobile } = getResponsiveValues();

      gsap.set(".home-nav", { y: -200, opacity: 0 });
      gsap.set(`#card${active}`, { x: 0, y: 0, width, height, zIndex: 20 });
      gsap.set(`#card-content-${active}`, { x: 0, y: 0, opacity: 0 });
      gsap.set(detailsActive, { opacity: 0, zIndex: 22, x: -200 });
      gsap.set(detailsInactive, { opacity: 0, zIndex: 12 });
      gsap.set(`${detailsInactive} .text`, { y: 100 });
      gsap.set(`${detailsInactive} .title-1`, { y: 100 });
      gsap.set(`${detailsInactive} .title-2`, { y: 100 });
      gsap.set(`${detailsInactive} .desc`, { y: 50 });
      gsap.set(`${detailsInactive} .cta`, { y: 60 });

      rest.forEach((i, index) => {
        gsap.set(`#card${i}`, { x: offsetLeft + index * (cardWidth + gap), y: offsetTop, width: cardWidth, height: cardHeight, zIndex: 30, borderRadius: 10 });
        gsap.set(`#card-content-${i}`, { x: offsetLeft + index * (cardWidth + gap), zIndex: 40, y: offsetTop + cardHeight - 100 });
      });

      gsap.set(".indicator", { x: -width });
      const startDelay = 0.6;

      gsap.to(".cover", { x: width + 400, delay: 0.5, ease, onComplete: () => setTimeout(() => loop(), 500) });
      rest.forEach((i, index) => {
        gsap.to(`#card${i}`, { x: offsetLeft + index * (cardWidth + gap), zIndex: 30, delay: 0.05 * index, ease });
        gsap.to(`#card-content-${i}`, { x: offsetLeft + index * (cardWidth + gap), zIndex: 40, delay: 0.05 * index, ease });
      });
      gsap.to(".home-nav", { y: 0, opacity: 1, ease, delay: startDelay });
      gsap.to(detailsActive, { opacity: 1, x: 0, ease, delay: startDelay });
    }

    function step() {
      return new Promise((resolve) => {
        order.push(order.shift() as number);
        detailsEven = !detailsEven;
        const detailsActive = detailsEven ? "#details-even" : "#details-odd";
        const detailsInactive = detailsEven ? "#details-odd" : "#details-even";
        const { cardWidth, cardHeight, gap, offsetTop, offsetLeft, width, height } = getResponsiveValues();

        const placeText = container.querySelector(`${detailsActive} .place-box .text`);
        const title1 = container.querySelector(`${detailsActive} .title-1`);
        const title2 = container.querySelector(`${detailsActive} .title-2`);
        const desc = container.querySelector(`${detailsActive} .desc`);
        
        if (placeText) placeText.textContent = data[order[0]].place;
        if (title1) title1.textContent = data[order[0]].title;
        if (title2) title2.textContent = data[order[0]].title2;
        if (desc) desc.textContent = data[order[0]].description;

        gsap.set(detailsActive, { zIndex: 22 });
        gsap.to(detailsActive, { opacity: 1, delay: 0.4, ease });
        gsap.to(`${detailsActive} .text`, { y: 0, delay: 0.1, duration: 0.7, ease });
        gsap.to(`${detailsActive} .title-1`, { y: 0, delay: 0.15, duration: 0.7, ease });
        gsap.to(`${detailsActive} .title-2`, { y: 0, delay: 0.15, duration: 0.7, ease });
        gsap.to(`${detailsActive} .desc`, { y: 0, delay: 0.3, duration: 0.4, ease });
        gsap.to(`${detailsActive} .cta`, { y: 0, delay: 0.35, duration: 0.4, onComplete: resolve, ease });
        gsap.set(detailsInactive, { zIndex: 12 });

        const [active, ...rest] = order;
        const prv = rest[rest.length - 1];

        gsap.set(`#card${prv}`, { zIndex: 10 });
        gsap.set(`#card${active}`, { zIndex: 20 });
        gsap.to(`#card${prv}`, { scale: 1.5, ease });
        gsap.to(`#card-content-${active}`, { y: offsetTop + cardHeight - 10, opacity: 0, duration: 0.3, ease });

        gsap.to(`#card${active}`, {
          x: 0, y: 0, ease, width, height, borderRadius: 0,
          onComplete: () => {
            const xNew = offsetLeft + (rest.length - 1) * (cardWidth + gap);
            gsap.set(`#card${prv}`, { x: xNew, y: offsetTop, width: cardWidth, height: cardHeight, zIndex: 30, borderRadius: 10, scale: 1 });
            gsap.set(`#card-content-${prv}`, { x: xNew, y: offsetTop + cardHeight - 100, opacity: 1, zIndex: 40 });
            gsap.set(detailsInactive, { opacity: 0 });
            gsap.set(`${detailsInactive} .text`, { y: 100 });
            gsap.set(`${detailsInactive} .title-1`, { y: 100 });
            gsap.set(`${detailsInactive} .title-2`, { y: 100 });
            gsap.set(`${detailsInactive} .desc`, { y: 50 });
            gsap.set(`${detailsInactive} .cta`, { y: 60 });
          },
        });

        rest.forEach((i, index) => {
          if (i !== prv) {
            const xNew = offsetLeft + index * (cardWidth + gap);
            gsap.set(`#card${i}`, { zIndex: 30 });
            gsap.to(`#card${i}`, { x: xNew, y: offsetTop, width: cardWidth, height: cardHeight, ease, delay: 0.1 * (index + 1) });
            gsap.to(`#card-content-${i}`, { x: xNew, y: offsetTop + cardHeight - 100, opacity: 1, zIndex: 40, ease, delay: 0.1 * (index + 1) });
          }
        });
      });
    }

    async function loop() {
      const { width } = getResponsiveValues();
      await new Promise(r => gsap.to(".indicator", { x: 0, duration: 2, onComplete: r }));
      await new Promise(r => gsap.to(".indicator", { x: width, duration: 0.8, delay: 0.3, onComplete: r }));
      gsap.set(".indicator", { x: -width });
      await step();
      loop();
    }

    async function loadImages() {
      const promises = data.map(({ image }) => new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = image;
      }));
      return Promise.all(promises);
    }

    loadImages().then(() => init()).catch(console.error);
  }, []);

  return (
    <div className="min-h-screen bg-[#f8f9fa] overflow-y-auto">
      {/* Hero Section with Slider */}
      <div ref={containerRef} className="relative w-full h-screen overflow-hidden bg-black font-['Oswald']">
        {/* Navigation */}
        <header>
          <nav className="home-nav fixed top-0 left-0 right-0 z-[100] flex items-center justify-between px-12 py-6" aria-label="Ana navigasyon">
            <Link to="/">
              <h1>
                <img 
                  src="https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/6b24d68bdeb9b34d218f93fb0e94b90c.png" 
                  alt="Adana İlkyardım Eğitim Merkezi - Sertifikalı İlkyardım ve İş Güvenliği Eğitimleri" 
                  title="Adana İlkyardım Eğitim Merkezi"
                  className="h-40 w-auto object-contain"
                />
              </h1>
            </Link>
            <ul className="flex gap-8 list-none">
              <li><Link to="/" className="text-white text-sm font-medium uppercase tracking-wide hover:text-[#ecad29] transition-colors relative pb-2 after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[3px] after:bg-[#ecad29] after:rounded">Ana Sayfa</Link></li>
              <li><Link to="/egitimler" className="text-white text-sm font-medium uppercase tracking-wide hover:text-[#ecad29] transition-colors">Eğitimler</Link></li>
              <li><Link to="/blog" className="text-white text-sm font-medium uppercase tracking-wide hover:text-[#ecad29] transition-colors">Blog</Link></li>
              <li><Link to="/iletisim" className="text-white text-sm font-medium uppercase tracking-wide hover:text-[#ecad29] transition-colors">İletişim</Link></li>
            </ul>
          </nav>
        </header>

        {/* Main Content */}
        <main>
          {/* Demo Container */}
          <div id="demo" className="absolute w-full h-full [&_.card]:absolute [&_.card]:bg-cover [&_.card]:bg-center [&_.card-content]:absolute [&_.card-content]:flex [&_.card-content]:flex-col [&_.card-content]:gap-0.5 [&_.card-content]:px-2 [&_.content-start]:h-1 [&_.content-start]:w-8 [&_.content-start]:bg-[#ecad29] [&_.content-start]:rounded [&_.content-place]:text-[10px] [&_.content-place]:text-[#ecad29] [&_.content-place]:font-medium [&_.content-place]:tracking-wide [&_.content-title-1]:text-sm [&_.content-title-1]:font-bold [&_.content-title-1]:text-white [&_.content-title-1]:leading-tight [&_.content-title-1]:drop-shadow-lg [&_.content-title-2]:text-sm [&_.content-title-2]:font-bold [&_.content-title-2]:text-white [&_.content-title-2]:leading-tight [&_.content-title-2]:drop-shadow-lg" aria-label="Eğitim programları slider"></div>

          {/* Details Even */}
          <article id="details-even" className="absolute left-8 md:left-12 top-1/2 -translate-y-1/2 max-w-[90vw] md:max-w-[35rem] z-50">
            <div className="place-box flex items-center gap-2 md:gap-3 mb-2 md:mb-4">
              <div className="start h-1.5 md:h-2 w-8 md:w-12 bg-[#ecad29] rounded"></div>
              <span className="text text-xs md:text-sm text-[#ecad29] font-medium tracking-wider">Sertifikalı Eğitim</span>
            </div>
            <div className="flex items-center gap-3 md:gap-4">
              <h2 className="title-1 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-none drop-shadow-lg">TEMEL</h2>
              <span className="title-2 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-none drop-shadow-lg">İLKYARDIM</span>
            </div>
            <p className="desc text-base md:text-lg lg:text-xl text-gray-200 leading-relaxed my-4 md:my-6 drop-shadow max-w-[320px] sm:max-w-none">İş yerlerinde zorunlu olan temel ilkyardım eğitimi ile çalışanlarınızı acil durumlara hazırlayın.</p>
            <Link to="/egitimler" className="cta inline-flex items-center gap-2 md:gap-3 px-5 md:px-8 py-3 md:py-4 bg-[#ecad29] text-black font-semibold rounded-full hover:bg-[#d49a1f] hover:-translate-y-0.5 hover:shadow-lg transition-all text-xs md:text-sm uppercase tracking-wide cursor-pointer whitespace-nowrap">
              <span>Detaylı Bilgi</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </article>

          {/* Details Odd */}
          <article id="details-odd" className="absolute left-8 md:left-12 top-1/2 -translate-y-1/2 max-w-[90vw] md:max-w-[35rem] z-50">
            <div className="place-box flex items-center gap-2 md:gap-3 mb-2 md:mb-4">
              <div className="start h-1.5 md:h-2 w-8 md:w-12 bg-[#ecad29] rounded"></div>
              <span className="text text-xs md:text-sm text-[#ecad29] font-medium tracking-wider">Yenileme Eğitimi</span>
            </div>
            <div className="flex items-center gap-3 md:gap-4">
              <h2 className="title-1 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-none drop-shadow-lg">İLKYARDIM</h2>
              <span className="title-2 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-none drop-shadow-lg">GÜNCELLEME</span>
            </div>
            <p className="desc text-base md:text-lg lg:text-xl text-gray-200 leading-relaxed my-4 md:my-6 drop-shadow max-w-[320px] sm:max-w-none">İlkyardımcı belgenizin süresi dolmak üzere mi? Güncelleme eğitimimiz ile bilgilerinizi tazeleyin.</p>
            <Link to="/egitimler" className="cta inline-flex items-center gap-2 md:gap-3 px-5 md:px-8 py-3 md:py-4 bg-[#ecad29] text-black font-semibold rounded-full hover:bg-[#d49a1f] hover:-translate-y-0.5 hover:shadow-lg transition-all text-xs md:text-sm uppercase tracking-wide cursor-pointer whitespace-nowrap">
              <span>Detaylı Bilgi</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </article>
        </main>

        {/* Indicator */}
        <div className="indicator absolute top-0 left-0 w-full h-1 bg-[#ecad29] z-[200]" aria-hidden="true"></div>
        
        {/* Cover */}
        <div className="cover absolute top-0 left-0 w-full h-full bg-black z-[300]" aria-hidden="true"></div>
      </div>

      {/* SEO Content Section - Adana İlkyardım Eğitimi */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 font-['Oswald'] mb-4">
              <a href="#adana-ilkyardim" id="adana-ilkyardim" className="hover:text-[#ecad29] transition-colors">
                ADANA'DA <span className="text-[#ecad29]">İLKYARDIM EĞİTİMİ</span>
              </a>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Sağlık Bakanlığı Onaylı <strong>Adana İlkyardım Eğitim Merkezi</strong> ile Profesyonel Sertifikalı Eğitimler
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20first%20aid%20training%20center%20in%20Adana%20Turkey%20with%20professional%20instructors%20teaching%20emergency%20response%20techniques%20bright%20spacious%20classroom%20with%20medical%20equipment%20CPR%20mannequins%20and%20certification%20materials%20contemporary%20educational%20facility&width=600&height=400&seq=adana1&orientation=landscape"
                alt="Adana İlkyardım Eğitim Merkezi - Sağlık Bakanlığı Onaylı Sertifikalı Eğitim"
                title="Adana'da İlkyardım Eğitimi"
                className="w-full h-[400px] object-cover object-top rounded-2xl shadow-xl"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 font-['Oswald']">
                <a href="#neden-adana" className="hover:text-[#ecad29] transition-colors">
                  Neden <span className="text-[#ecad29]">Adana İlkyardım Eğitimi?</span>
                </a>
              </h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>Adana ilkyardım eğitimi</strong> arayan işletmeler ve bireyler için Sağlık Bakanlığı onaylı, uygulamalı ve sertifikalı eğitim programları sunuyoruz. <strong>Adana'da ilkyardım kursu</strong> veren en deneyimli eğitim merkezlerinden biriyiz.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Adana Seyhan, Çukurova, Yüreğir, Sarıçam ve tüm ilçelerde hizmet veren merkezimiz, <strong>Adana iş güvenliği eğitimi</strong> ve <strong>Adana sertifikalı ilkyardım eğitimi</strong> konusunda 10 yılı aşkın deneyime sahiptir.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ecad29] text-xl flex-shrink-0 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-gray-700"><strong>Sağlık Bakanlığı Onaylı</strong> sertifika programları</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ecad29] text-xl flex-shrink-0 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-gray-700">Deneyimli ve <strong>IRATA sertifikalı eğitmenler</strong></span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ecad29] text-xl flex-shrink-0 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-gray-700">Modern eğitim ekipmanları ve <strong>uygulamalı eğitim</strong></span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#ecad29] text-xl flex-shrink-0 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-gray-700"><strong>Adana merkezi konumda</strong> kolay ulaşım</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Eğitim Programları Özeti */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 font-['Oswald']">
                <a href="#egitim-programlari" className="hover:text-[#ecad29] transition-colors">
                  <span className="text-[#ecad29]">ADANA'DA</span> VERDİĞİMİZ EĞİTİMLER
                </a>
              </h3>
              <div className="space-y-4">
                <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg hover:bg-[#ecad29]/5 transition-colors">
                  <i className="ri-heart-pulse-line text-[#ecad29] text-2xl flex-shrink-0 mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Adana Temel İlkyardım Eğitimi</h4>
                    <p className="text-sm text-gray-600">16 saatlik Sağlık Bakanlığı onaylı <strong>sertifikalı ilkyardım kursu</strong></p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg hover:bg-[#ecad29]/5 transition-colors">
                  <i className="ri-shield-check-line text-[#ecad29] text-2xl flex-shrink-0 mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Adana İş Güvenliği Eğitimi</h4>
                    <p className="text-sm text-gray-600"><strong>Yüksekte çalışma</strong>, yangın güvenliği ve acil durum eğitimleri</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg hover:bg-[#ecad29]/5 transition-colors">
                  <i className="ri-award-line text-[#ecad29] text-2xl flex-shrink-0 mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Adana MYK Belgesi Eğitimleri</h4>
                    <p className="text-sm text-gray-600">Forklift, vinç operatörlüğü ve <strong>mesleki yeterlilik eğitimleri</strong></p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg hover:bg-[#ecad29]/5 transition-colors">
                  <i className="ri-restaurant-line text-[#ecad29] text-2xl flex-shrink-0 mt-1 w-6 h-6 flex items-center justify-center"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Adana Hijyen Eğitimi</h4>
                    <p className="text-sm text-gray-600">Gıda sektörü için zorunlu <strong>HACCP hijyen eğitimi</strong></p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Group%20of%20diverse%20professionals%20receiving%20first%20aid%20certification%20in%20Adana%20training%20center%20happy%20graduates%20holding%20certificates%20modern%20bright%20classroom%20with%20Turkish%20flag%20professional%20achievement%20celebration&width=600&height=400&seq=adana2&orientation=landscape"
                alt="Adana İlkyardım Sertifikası Alan Kursiyerler - Başarılı Mezunlar"
                title="Adana Sertifikalı İlkyardım Eğitimi Mezunları"
                className="w-full h-[400px] object-cover object-top rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#1a1a1a]">
        <div className="max-w-4xl mx-auto text-center">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-4 font-['Oswald']">
            <a href="/iletisim" className="hover:text-[#ecad29] transition-colors">
              ADANA'DA <span className="text-[#ecad29]">İLKYARDIM EĞİTİMİ</span> ALMAK İÇİN
            </a>
          </h3>
          <p className="text-gray-400 text-lg mb-8 max-w-2xl mx-auto">
            <strong>Adana ilkyardım kursu</strong> ve <strong>iş güvenliği eğitimi</strong> için hemen bizimle iletişime geçin. Kurumsal eğitim teklifleri için özel fiyatlandırma avantajları.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link 
              to="/iletisim"
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#ecad29] text-white rounded-full font-semibold hover:bg-[#d49a1f] transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg text-base"
            >
              <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
              <span>Hemen Başvur</span>
            </Link>
            <Link 
              to="/egitimler"
              className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white text-white rounded-full font-semibold hover:bg-white hover:text-black transition-all whitespace-nowrap cursor-pointer text-base"
            >
              <i className="ri-book-open-line w-5 h-5 flex items-center justify-center"></i>
              <span>Eğitimleri İncele</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white border-y">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-[#ecad29] font-['Oswald'] mb-2">5000+</div>
              <div className="text-sm text-gray-600">Adana'da Eğitim Alan Kursiyerimiz</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#ecad29] font-['Oswald'] mb-2">15+</div>
              <div className="text-sm text-gray-600">Farklı Sertifikalı Eğitim Programı</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#ecad29] font-['Oswald'] mb-2">%98</div>
              <div className="text-sm text-gray-600">Adana İlkyardım Eğitimi Memnuniyet</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-[#ecad29] font-['Oswald'] mb-2">10+</div>
              <div className="text-sm text-gray-600">Yıllık Adana İş Güvenliği Deneyimi</div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-6 px-4 sm:px-6 lg:px-8 bg-[#f0e6d2]">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-600 text-sm">© 2025 Adana İlkyardım Eğitim Merkezi. Tüm hakları saklıdır.</p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer nofollow"
            className="text-gray-500 text-xs hover:text-gray-700 transition-colors"
          >
            Web Design
          </a>
        </div>
      </footer>

      {/* Contact Icons */}
      <aside className="fixed bottom-6 left-6 z-[150] flex flex-col gap-3" aria-label="İletişim butonları">
        <a 
          href="https://wa.me/905324196401" 
          target="_blank" 
          rel="noopener noreferrer nofollow"
          className="w-12 h-12 flex items-center justify-center bg-[#25D366] text-white rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer"
          title="WhatsApp ile iletişime geçin"
          aria-label="WhatsApp"
        >
          <i className="ri-whatsapp-line text-xl"></i>
        </a>
        <a 
          href="mailto:info@assaakademi.com.tr" 
          className="w-12 h-12 flex items-center justify-center bg-[#ecad29] text-black rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer"
          title="E-posta gönderin"
          aria-label="E-posta"
        >
          <i className="ri-mail-line text-xl"></i>
        </a>
        <a 
          href="tel:08503462772" 
          className="w-12 h-12 flex items-center justify-center bg-white text-black rounded-full hover:scale-110 hover:shadow-lg transition-all cursor-pointer shadow-md"
          title="Bizi arayın: 0850 346 2772"
          aria-label="Telefon"
        >
          <i className="ri-phone-line text-xl"></i>
        </a>
      </aside>
    </div>
  );
}
